import {FinanceOperationsStore} from '@/store/modules/Finance/FinanceOperations';
import {LoyaltyCertStore} from '@/store/modules/Loyalty/Cert/LoyaltyCert';
import {OperationsStore} from '@/store/modules/Warehouse/Operations';
import {Action, getModule, Module, MutationAction, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {SalonsStore} from '@/store/modules/Salons';
import {ProductsStore} from '@/store/modules/Warehouse/Products';
import {appPaginationStore} from '@/store/modules/appPagination';
import {ClientsStore} from '@/store/modules/Clients';
import {RouterNameEnum} from '@/router/router.types';
//import { router } from '@/router/router';
import {RouterProperties} from '@/router/routerProperties';
import {Vue} from 'vue-property-decorator';
import {VisitsStore} from '@/store/modules/Visits';
import {clientsAccountsHistoryStore} from '@/store/modules/ClientsAccountHistory';
import {LoyaltySubscriptionStore} from './Loyalty/Subscription/LoyaltySubscription';
import Vuex from "vuex";

@Module({
    namespaced: true,
    name: 'appFilters',
    store,
    dynamic: true,
})
class appFilters extends VuexModule {
    public salons: { [s: string]: string } = {};
    public clients: { [c: string]: string } = {};
    public clientVisits: { [cv: string]: string } = {};


    public stores: { [t: string]: string } = {};
    public products: { [p: string]: string } = {};
    public operations: { [o: string]: string } = {};
    public warehouse: { [w: string]: string } = {};
    public settingsUser: { [su: string]: string } = {};
    public financeOperations: { [su: string]: string } = {};
    public loyaltyCerts: { [lc: string]: string } = {};
    public loyaltyCertsType: { [lt: string]: string } = {};

    public loyaltySubscription: { [ls: string]: string } = {};
    public loyaltySubscriptionType: { [lst: string]: string } = {};

    public clientDocoments: { [cd: string]: string } = {};
    public clientsAccountsHistory: { [ca: string]: string } = {};
    public clientsAccountsAll: { [caa: string]: string } = {};
    public clientsNotes: { [cn: string]: string } = {};
    public salonDetailClients: { [sd: string]: string } = {};
    public salon_id: { [si: string]: string } = {};
    public counterparties: { [cp: string]: string } = {};
    public salonsDetailFinance: { [sf: string]: string } = {};

    public filter: Record<any, any> = {};
    public currentStore: Record<any, any> = {};
    public container: string = '';

    //cities: any

    @Mutation
    public isFilter(val: any): boolean {
        let result = false;
        if (val.source === 'salons') {
            result = val.key in this.salons;
        }
        if (val.source === 'clients') {
            result = val.key in this.clients;
        }
        if (val.source === 'stores') {
            result = val.key in this.stores;
        }
        if (val.source === 'products') {
            result = val.key in this.products;
        }
        if (val.source === 'operations') {
            result = val.key in this.operations;
        }
        if (val.source === 'warehouse') {
            result = val.key in this.warehouse;
        }
        if (val.source === 'settingsUser') {
            result = val.key in this.settingsUser;
        }
        if (val.source === 'loyaltyCerts') {
            result = val.key in this.loyaltyCerts;
        }
        if (val.source === 'loyaltyCertsType') {
            result = val.key in this.loyaltyCertsType;
        }
        if (val.source === RouterProperties.loyaltySubscription) {
            result = val.key in this.loyaltySubscription;
        }
        if (val.source === RouterProperties.loyaltySubscriptionType) {
            result = val.key in this.loyaltySubscriptionType
        }

        if (val.source === RouterProperties.clientDocuments) {
            result = val.key in this.clientDocoments;
        }
        if (val.source === RouterProperties.clientVisits) {
            result = val.key in this.clientVisits
        }
        if (val.source === RouterProperties.clientsAccountsHistory) {
            result = val.key in this.clientsAccountsHistory
        }
        if (val.source === RouterProperties.clientsaccountsAll) {
            result = val.key in this.clientsAccountsAll
        }
        if (val.source === RouterProperties.clientNotes) {
            result = val.key in this.clientsNotes
        }
        return result;
    }

    @Mutation
    public async clearAllfiltersClients() {
        this.clients = {};
    }

    @Mutation
    public async clearAllfiltersSalon() {
        this.salons = {};
    }

    @Mutation
    public async clearfilterSalonField(field: any) {
        appPaginationStore.setLoad(false);
        delete this.salons[field];
        await SalonsStore.fetchAll({limit: appPaginationStore.PageParams.pageSize, filter: this.salons});
        appPaginationStore.setTotal(SalonsStore.salons!.total);
        appPaginationStore.setLoad(true);
    }

    @Mutation
    //public async changeFilter(source:string,mode:string,value:any)
    public async changeFilter(data: any) {
        await appFiltersStore.setFiltersSource(data);
    }

    @Mutation
    public async applyFilter() {
        appPaginationStore.setLoad(false);

        await this.currentStore.fetchAll({limit: appPaginationStore.PageParams.pageSize, filter: this.filter});

        appPaginationStore.setTotal(this.currentStore[this.container].total);
        appPaginationStore.setLoad(true);
    }

    @Mutation
    //public async setFiltersSource(source:any, value:any){
    public async setFiltersSource(data: any) {
        appPaginationStore.setLoad(false);

        const key = Object.keys(data.data)[0];
        let total = 0;

        appPaginationStore.setCurrent(1);
        this.filter = {...this.filter, ...data.data};

        if (data.source === RouterProperties.loyaltySubscription) {
            this.currentStore = LoyaltySubscriptionStore;
            this.container = 'loyaltySubscriptions';

            if (this.currentStore[this.container]?.total) {
                total = this.currentStore[this.container].total;
            }
            await Vue.router.push({
                name: RouterNameEnum.LoyaltySubscriptionPage,
                params: {
                    page: '1',
                    total: total.toString(),
                    filter: JSON.stringify(this.filter),
                },
            });
        }

        if (data.source === RouterProperties.operations) {

            this.currentStore = OperationsStore;
            this.container = 'operations';

            if (this.currentStore[this.container]?.total) {
                total = this.currentStore[this.container].total;
            }

            await Vue.router.push({
                name: RouterNameEnum.StoreOperationsPage,
                params: {
                    page: '1',
                    total: total.toString(),
                    filter: JSON.stringify(this.filter),
                },
            });
        }

        if (data.source === RouterProperties.salonsDetailFinance) {
            this.currentStore = FinanceOperationsStore;
            this.container = 'items';
            this.filter.salon_id = Vue.router.currentRoute.params['id'] as any

            if (this.currentStore[this.container]?.total) {
                total = this.currentStore[this.container].total;
            }
            await Vue.router.push({
                name: RouterNameEnum.SalonDetailFinancePage,
                params: {
                    page: '1',
                    total: total.toString(),
                    filter: JSON.stringify(this.filter),
                },
            });
        }

        if (data.source === RouterProperties.salonDetailClients) {

            this.currentStore = ClientsStore;
            this.container = 'clients';

            if (this.currentStore[this.container]?.total) {
                total = this.currentStore[this.container].total;
            }

            await Vue.router.push({
                name: RouterNameEnum.SalonDetailClientsPage,
                params: {
                    page: '1',
                    total: total.toString(),
                    filter: JSON.stringify(this.filter),
                },
            });
        }

        if (data.source === RouterProperties.salons) {
            this.currentStore = SalonsStore;
            this.container = 'salons';

            if (this.currentStore[this.container]?.total) {
                total = this.currentStore[this.container].total;
            }
            await Vue.router.push({
                name: RouterNameEnum.SalonsPage,
                params: {
                    page: '1',
                    total: total.toString(),
                    filter: JSON.stringify(this.filter),
                },
            });
        }

        if (data.source === RouterProperties.clients) {
            this.currentStore = ClientsStore;
            this.container = 'clients';

            if (this.currentStore[this.container]?.total) {
                total = this.currentStore[this.container].total;
            }
            await Vue.router.push({
                name: RouterNameEnum.ClientsPage,
                params: {
                    page: '1',
                    total: total.toString(),
                    filter: JSON.stringify(this.filter),
                },
            });
        }

        if (data.source === RouterProperties.stores) {
            this.stores[key] = data.data[Object.keys(data.data)[0]];
        }

        if (data.source === RouterProperties.products) {
            this.products[key] = data.data[Object.keys(data.data)[0]];
            await ProductsStore.fetchAll({limit: appPaginationStore.PageParams.pageSize, filter: this.products});

            if (ProductsStore.products?.total) {
                total = ProductsStore.products?.total;
            }
            await Vue.router.replace({
                name: RouterNameEnum.StoresProductsPage,
                params: {
                    page: '1',
                    total: appPaginationStore.PageParams.total.toString(),
                    filter: JSON.stringify(this.products),
                },
            });
        }

        if (data.source === RouterProperties.financeOperations) {
            // Не понял эту конструкцию... Берет же только один элемент.
            //this.financeOperations[key] = data.data[Object.keys(data.data)[0]];
            Object.keys(data.data).map((key: string) => {
                if (data.data[key]) {
                    this.financeOperations[key] = data.data[key];
                } else {
                    delete this.financeOperations[key];
                }
            });

            await FinanceOperationsStore.fetchAll({
                limit: appPaginationStore.PageParams.pageSize,
                filter: this.financeOperations,
            });
            if (FinanceOperationsStore.items?.total) {
                total = FinanceOperationsStore.items?.total as number;
            }
            await Vue.router.replace({
                name: RouterNameEnum.FinanceOperationsPage,
                params: {
                    page: '1',
                    page_size: appPaginationStore.PageParams.pageSize.toString(),
                    total: appPaginationStore.PageParams.total.toString(),
                    filter: JSON.stringify(this.financeOperations),
                },
            });
        }
        if (data.source === RouterProperties.loyaltyCert) {
            this.loyaltyCerts[key] = data.data[Object.keys(data.data)[0]];
            await LoyaltyCertStore.fetchAll({
                limit: appPaginationStore.PageParams.pageSize,
                filter: this.loyaltyCerts,
            });
            if (LoyaltyCertStore.loyaltyCerts?.total) {
                total = LoyaltyCertStore.loyaltyCerts?.total as number;
            }

            await Vue.router.replace({
                name: RouterNameEnum.LoyaltyCertPage,
                params: {
                    page: '1',
                    total: appPaginationStore.PageParams.total.toString(),
                    filter: JSON.stringify(this.operations),
                },
            });
        }
        if (data.source === RouterProperties.clientVisits) {
            this.clientVisits[key] = data.data[Object.keys(data.data)[0]];
            await VisitsStore.fetchAll({
                limit: appPaginationStore.PageParams.pageSize,
                filter: this.clientVisits,
            })
            if (VisitsStore.visits?.total) {
                total = VisitsStore.visits?.total as number;
            }
            await Vue.router.replace({
                name: RouterNameEnum.ClientDetailHistoryPage,
                params: {
                    page: '1',
                    total: appPaginationStore.PageParams.total.toString(),
                    filter: JSON.stringify(this.operations),
                },
            })
        }

        if (data.source === RouterProperties.clientsAccountsHistory) {
            this.clientsAccountsHistory[key] = data.data[Object.keys(data.data)[0]];
            await clientsAccountsHistoryStore.fetchAll({
                limit: appPaginationStore.PageParams.pageSize,
                filter: this.clientVisits,
            })
            if (clientsAccountsHistoryStore.items?.total) {
                total = clientsAccountsHistoryStore.items?.total as number;
            }
            await Vue.router.replace({
                name: RouterNameEnum.ClientAccountsPage,
                params: {
                    page: '1',
                    total: appPaginationStore.PageParams.total.toString(),
                    filter: JSON.stringify(this.operations),
                },
            })
        }

        if (data.source === RouterProperties.clientNotes) {
            this.clientsNotes[key] = data.data[Object.keys(data.data)[0]];
            await clientsAccountsHistoryStore.fetchAll({
                limit: appPaginationStore.PageParams.pageSize,
                filter: this.clientsNotes,
            })
            if (clientsAccountsHistoryStore.items?.total) {
                total = clientsAccountsHistoryStore.items?.total as number;
            }
            await Vue.router.replace({
                name: RouterNameEnum.ClientDetailHistoryPage,
                params: {
                    page: '1',
                    total: appPaginationStore.PageParams.total.toString(),
                    filter: JSON.stringify(this.operations),
                },
            })

        }


        if (data.source === RouterProperties.warehouse) {
            this.warehouse[key] = data.data[Object.keys(data.data)[0]];
        }
        appPaginationStore.setTotal(total);
        appPaginationStore.setLoad(true);
    }

    @Mutation
    public async clearfilterSalon(value: any) {
        appPaginationStore.setLoad(false);
        const key = Object.keys(value)[0];
        delete this.salons[key];
        await SalonsStore.fetchAll({limit: appPaginationStore.PageParams.pageSize, filter: this.salons});
        appPaginationStore.setTotal(SalonsStore.salons!.total);
        appPaginationStore.setLoad(true);
    }

    @Mutation
    public async setfiltersSalons(value: any) {
        this.salons = value;
    }

    @Mutation
    public async setfiltersClients(value: any) {
        this.clients = value;
    }

    @Mutation
    public async setfiltersStores(value: any) {
        this.stores = value;
    }

    @Mutation
    public async setfilterProducts(value: any) {
        appPaginationStore.setLoad(false);
        const key = Object.keys(value)[0];
        this.products[key] = value[Object.keys(value)[0]];
        appPaginationStore.setCurrent(1);
        await ProductsStore.fetchAll({limit: appPaginationStore.PageParams.pageSize, filter: this.products});
        appPaginationStore.setTotal(ProductsStore.products!.total);

        Vue.router.replace({
            name: RouterNameEnum.StoresProductsPage,
            params: {
                page: '1',
                total: appPaginationStore.PageParams.total.toString(),
                filter: JSON.stringify(this.products),
            },
        });
        appPaginationStore.setLoad(true);
    }

    @Mutation
    public async setfilterSalons(value: any) {
        appPaginationStore.setLoad(false);
        const key = Object.keys(value)[0];
        this.salons[key] = value[Object.keys(value)[0]];
        //appPaginationStore.setSalonsFilter(this.salons)
        appPaginationStore.setCurrent(1);

        await SalonsStore.fetchAll({limit: appPaginationStore.PageParams.pageSize, filter: this.salons});
        appPaginationStore.setTotal(SalonsStore?.salons!.total);
        const routeName = RouterNameEnum.SalonsPage;

        Vue.router.replace({
            name: routeName,
            params: {
                page: '1',
                total: appPaginationStore.PageParams.total.toString(),
                filter: JSON.stringify(this.salons),
            },
        });
        appPaginationStore.setLoad(true);
    }

    @Mutation
    public async setfilterClients(value: any) {
        appPaginationStore.setLoad(false);
        const key = Object.keys(value)[0];
        this.clients[key] = value[Object.keys(value)[0]];
        //appPaginationStore.setSalonsFilter(this.salons)
        appPaginationStore.setCurrent(1);

        await ClientsStore.fetchAll({limit: appPaginationStore.PageParams.pageSize, filter: this.clients});
        appPaginationStore.setTotal(ClientsStore.clients!.total);
        Vue.router.replace({
            name: RouterNameEnum.ClientsPage,
            params: {
                page: '1',
                total: appPaginationStore.PageParams.total.toString(),
                filter: JSON.stringify(this.clients),
            },
        });

        appPaginationStore.setLoad(true);
        /*const key=Object.keys(value)[0]
        this.clients[key] = value[Object.keys(value)[0]]*/
    }

    @Mutation
    public setfilterStores(value: any) {
        const key = Object.keys(value)[0];
        this.stores[key] = value[Object.keys(value)[0]];
    }

    get SalonsFilter() {
        return this.salons;
    }

    get ClientsFilter() {
        return this.clients;
    }

    get StoresFilter() {
        return this.stores;
    }

    get ProductsFilter() {
        return this.products;
    }

    get OperationsFilter() {
        return this.operations;
    }
}

export const appFiltersStore = getModule(appFilters);
